<template>
  <v-container>
      <h2 class="my-5 text-center">Why Choose Guiomentor</h2>
    <v-row>
      <v-col  v-for="(option, index) in options" :key="index" cols="12" md="4" lg="4">
        <v-card elevation="5" max-width="100%" class="card text-center animate__animated animate__slideInUp">
         <div class="icon-wrap d-flex justify-center">
           <v-avatar class="mt-5">
             <v-img :src="option.icon"/>
           </v-avatar>
         </div>

          <v-card-title class="d-flex justify-center">
            {{option.title}}
          </v-card-title>
          <v-card-subtitle class="text-center">
            {{option.subtitle}}
          </v-card-subtitle>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
data() {
  return {
    options: [
        {
          icon: 'https://guiomentor.com/wp-content/uploads/elementor/thumbs/icons8-student-64-pc6g56mw4ecib56tkn1cum075loyfiraqqwnc1ij5g.png',
          title: "Mentee/Student",
          subtitle: "Mentees are more engaged and interested in learning through Guiomentor"
          
          },
      {
        icon: 'https://guiomentor.com/wp-content/uploads/elementor/thumbs/education-pc6ggrz8eu7ti0clvnfploouwojxd4s4c4k8ewbqes.png',
        title: "Mentor",
        subtitle: "Mentors save time and are able to focus their efforts on individual Mentee."
      },
      {
        icon: 'https://guiomentor.com/wp-content/uploads/elementor/thumbs/parents-pc6gkavg1h1j1d8aaoacgao33p6h89rvtkms793l2s.png',
        title: "Parents",
        subtitle: "Parents get immediate and relevant feedback to support their child’s learning journey."
      },
    ]
  }
}
}
</script>

<style lang="scss">
.card {
  cursor: pointer;
 
}
</style>
